var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"height100"},[_c('el-container',[_c('el-header',{staticStyle:{"height":"auto","padding":"0"}},[_c('Head'),_vm._v(" "),_c('Tabs')],1),_vm._v(" "),_c('el-container',[_c('el-aside',{attrs:{"width":"210px"}},[_c('LeftMenu')],1),_vm._v(" "),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31a50c0b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/manage/index.vue
// module id = null
// module chunks = 